<script setup lang="ts">
import Icon from "./Icon.vue";

export type ButtonVariant = "default" | "primary" | "danger" | "ghost";

withDefaults(defineProps<{
  variant?: ButtonVariant;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  icon?: string;
  iconEnd?: string;
}>(), {
  variant: "default",
  type: "button",
  disabled: false,
  icon: "",
  iconEnd: "",
});
</script>

<template>
  <button class="ro-btn" :class="`ro-btn--${variant}`" :type="type" :disabled="disabled">
    <Icon v-if="icon" :name="icon" />
    <slot />
    <Icon v-if="iconEnd" :name="iconEnd" />
  </button>
</template>
